/* USE PROTECTION design: the cart drawer's behaviour (markup: snippets/up-cart.liquid inside sections/mini-cart.liquid's
   <cart-drawer id="mini-cart">; styles: assets/up-sections.css + assets/up-skin-cart.css).

   theme.js replaces the drawer's innerHTML on every cart:refresh, so NOTHING here is bound to a drawer node: every
   listener is delegated from <html>, open/closed states that must survive a rebuild live on <body>, and paint() re-runs
   on cart-drawer:loaded (theme.js fires it synchronously after the swap, before the browser paints).

   What this file does NOT do, because the live code already does it on the same markup:
   - quantity +/- and remove: theme.js <line-item-quantity> (POST /cart/update.js with sections, mfGiftOne.settle,
     cart:updated + cart:refresh); here only the busy look of the line while it runs;
   - the 1+1 picker / configurator / add: assets/promo22.js; the protector add: assets/custom.js;
   - the mystery gift: snippets/mf-gift-one.liquid;
   - the coupon field's reveal step (cpnh:reveal) and body.mf-cpn-reveal: assets/custom.js ([data-mf-cpn-reveal]).

   What it does:
   1. "Detalii comandă" folds the summary rows open (body.u-sum-open).
   2. "Cod de reducere": the field opens (body.mf-cpn-reveal, set here too when custom.js is absent) and takes focus;
      with a code on the cart, "Alt cod de reducere" (same spot) opens the same field for a second one (body.u-code-more).
   3. Coupon apply: the live sequence (assets/mf-popup-game.js applyCode): /discount/CODE (Shopify's cookie; with
      ?redirect=/cart.js, so the redirect lands on a small JSON instead of a server-rendered home page), then
      /cart/update.js { discount: every held code + this one, sections }, inside window.mfCartLock when it exists. A code
      the cart does not accept (discount_codes[].applicable false or missing) is taken off again, its cookie dropped,
      and the drawer says so (in the field and in a live region outside the drawer, which survives the repaint); an
      accepted one books mf_cart_step coupon_apply (the step dCart's Apply used to send) and closes the field.
   4. Coupon remove (the x on a code row): custom.js's removal - the other codes are sent back, the cookie dropped
      when it held this code or no code is left; the field closes, as in the mockup.
   5. 1+1: the + slot scrolls the picker rail into view; a rail tile whose case costs no more than the cheapest paid
      case in the cart (data-p11-cents <= data-p11-floor: the Function frees it) reads "+ Gratis", any other keeps the
      server's "+ Adaugă"; an opened configurator is brought into view (the live drawer's behaviour).
   6. The remembered phone (localStorage mf_dev1, assets/mf-device.js): in the empty cart the CTA and the mood tiles
      follow it ("Vezi husele pentru <phone>" -> its collection, a mood -> <collection>/<mood tag>, as the live menu
      does); in the 1+1 strip a + slot with no picker behind it links to its collection.
   7. The delivery days: the two weekdays of the live label (today + days_range_1 / _2, the browser's date) on every
      paint, over the server's text.
   8. Focus: a quantity / remove / protector / code control the shopper used gets focus back after theme.js swaps the
      drawer (the same control of the same line - found by its key, or by its variant when Shopify re-keyed it - else
      the control in the same place, else the line's name, else the close button); a rejected code, the field.
   9. The drawer A/B the live theme runs (assets/mf-dr.js) tags carts mf_dr / mf_drc. This drawer is no arm of it, so a
      cart that arrives tagged (sections/mini-cart.liquid prints the server cart's tags) is cleaned as mf-dr.js does
      outside 'ab': both attributes blanked in one write through window.mfCartLock, once the cart holds items, 3 tries
      per page at most.
   Cart writes always post sections: 'mini-cart' and announce cart:updated + cart:refresh with the returned cart, so the
   drawer paints from the response (theme.js) and mfCart / mfGiftOne see the new cart.
   Multistore (2026-10-25): every word is the store's mf.up.cart.* key through window.mfT (snippets/mf-l10n.liquid); a
   missing key leaves the server's text in place. The "+ Gratis" tile word is a 1+1 claim and only shows on a p11 store
   (window.__mfStore.offer, snippets/mf-ctl-head.liquid). */
(function () {
  'use strict';
  var D = document, H = D.documentElement, W = window;
  if (W.__upCart) { return; }
  W.__upCart = true;

  function q(sel) { return D.querySelector(sel); }
  function qa(sel) { return D.querySelectorAll(sel); }
  function calm() { return !!(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function same(a, b) { return String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase(); }
  function track(step) { try { if (W.mfTrackPush) { W.mfTrackPush('mf_cart_step', { mf_step: step }); } } catch (e) {} }
  function lock(job) { return W.mfCartLock ? W.mfCartLock(job) : job(); }
  /* the store's words (mf.up.cart.<k>); '' when the key or mfT is missing */
  function t(k, vars) { try { return W.mfT ? String(W.mfT('up.cart.' + k, vars) || '') : ''; } catch (e) { return ''; } }
  /* the store's offer: p11 (1+1), p22 (2+2), none; RO's p11 when the store constants are absent */
  var OFFER = (W.__mfStore && W.__mfStore.offer) || 'p11';

  function readCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) {
      if (!r.ok) { throw new Error('/cart.js ' + r.status); }
      return r.json();
    });
  }
  function post(url, body) {
    body.sections = 'mini-cart';
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) { throw new Error(url + ' ' + r.status); }
      return r.json();
    });
  }
  function announce(cart) {
    if (!cart) { return; }
    try { if (W.mfCart && W.mfCart.invalidate) { W.mfCart.invalidate(); } } catch (e) {}
    H.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    H.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
  }
  /* every code the cart holds (custom.js's reader when present: cart- and line-level applications too) */
  function heldCodes(cart) {
    if (W.mfDiscountCodes) { return W.mfDiscountCodes(cart, false); }
    var out = [];
    ((cart && cart.discount_codes) || []).forEach(function (d) { if (d && d.code) { out.push(d.code); } });
    return out;
  }
  function accepted(cart, code) {
    return ((cart && cart.discount_codes) || []).some(function (d) { return d && same(d.code, code) && d.applicable; });
  }
  function dropCookie(code, noneLeft) {
    var c = (D.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/) || [])[1] || '';
    try { c = decodeURIComponent(c); } catch (e) {}
    if (noneLeft || same(c, code)) { D.cookie = 'discount_code=; Max-Age=0; path=/'; }
  }

  /* ── 1. summary fold (and the aria-expanded of the three toggles, whose state lives on <body>) ─────────── */
  function expanded(sel, cls) {
    var on = D.body.classList.contains(cls), b = qa(sel), i;
    for (i = 0; i < b.length; i++) { b[i].setAttribute('aria-expanded', on ? 'true' : 'false'); }
  }
  function syncSum() {
    expanded('#mini-cart [data-u-sum]', 'u-sum-open');
    expanded('#mini-cart [data-u-code-open]', 'mf-cpn-reveal');
    expanded('#mini-cart [data-u-code-more]', 'u-code-more');
  }
  function fieldFocus() {
    W.setTimeout(function () { var i = q('#mini-cart [data-u-cform] input'); if (i) { try { i.focus({ preventScroll: true }); } catch (e) { i.focus(); } } }, 30);
  }

  /* a live region outside <cart-drawer>: the drawer's own nodes are replaced on every repaint, so a message written
     into them may never be announced */
  var live = null;
  function liveRegion() {
    if (live || !D.body) { return live; }
    live = D.createElement('div');
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('data-u-cart-live', '');
    live.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;border:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap';
    D.body.appendChild(live);
    return live;
  }
  function say(text) {
    var r = liveRegion();
    if (!r) { return; }
    r.textContent = '';
    if (text) { W.setTimeout(function () { r.textContent = text; }, 80); }
  }

  /* ── 3. coupon apply ─────────────────────────────────────────────────────── */
  var busy = false, errFor = '';
  function showErr(text) {
    var p = q('#mini-cart [data-u-cerr]');
    if (p) {
      p.textContent = text || '';
      p.hidden = !text;
    }
    if (text) { say(text); }
  }
  function apply(form) {
    var input = form.querySelector('input'), code = input ? String(input.value || '').trim() : '';
    if (!code || busy) { return; }
    busy = true;
    errFor = '';
    /* after the repaint the field is gone (accepted) - the focus goes to the button in its spot; a rejected code puts
       it back into the field (paint) */
    refocus = { key: '', label: '', text: '', t: Date.now(), fallback: '#mini-cart [data-u-code-more], #mini-cart [data-u-code-open]' };
    form.setAttribute('aria-busy', 'true');
    showErr('');
    var held = [];
    lock(function () {
      return fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' }).then(null, function () {})
        .then(readCart)
        .then(function (cart) {
          held = heldCodes(cart).filter(function (c) { return !same(c, code); });
          return post('/cart/update.js', { discount: held.concat([code]).join(',') });
        })
        .then(function (after) {
          if (accepted(after, code)) { return { ok: true, cart: after }; }
          dropCookie(code, !held.length);
          return post('/cart/update.js', { discount: held.join(',') }).then(function (back) { return { ok: false, cart: back }; });
        });
    }).then(function (res) {
      busy = false;
      form.removeAttribute('aria-busy');
      if (res.ok) {
        track('coupon_apply');
        /* the field closes (the mockup's state after Aplică); the code row and "Alt cod de reducere" take its place */
        D.body.classList.remove('u-code-more');
        say(t('code_applied', { code: code }));
      } else { errFor = code; }
      announce(res.cart);
    }, function () {
      busy = false;
      form.removeAttribute('aria-busy');
      showErr(t('code_error'));
    });
  }

  /* ── 4. coupon remove ────────────────────────────────────────────────────── */
  function removeCode(btn) {
    var code = btn.getAttribute('data-u-code-rm') || '';
    if (!code || btn.hasAttribute('aria-busy')) { return; }
    btn.setAttribute('aria-busy', 'true');
    var row = btn.closest('.u-sum-row');
    if (row) { row.style.opacity = '.5'; }
    lock(function () {
      return readCart().then(function (cart) {
        var held = heldCodes(cart);
        /* a row painted from an older cart: the code is already gone - just repaint (theme.js fetches the section) */
        if (!held.some(function (c) { return same(c, code); })) { return cart; }
        var keep = held.filter(function (c) { return !same(c, code); });
        return post('/cart/update.js', { discount: keep.join(',') }).then(function (after) {
          dropCookie(code, !keep.length);
          return after;
        });
      });
    }).then(function (cart) {
      /* the mockup's state after the x: no field, "Cod de reducere" back */
      D.body.classList.remove('mf-cpn-reveal', 'u-code-more');
      refocus = { key: '', label: '', text: '', t: Date.now(), fallback: '#mini-cart [data-u-code-open], #mini-cart [data-u-code-more]' };
      announce(cart);
    }, function () {
      btn.removeAttribute('aria-busy');
      if (row) { row.style.opacity = ''; }
    });
  }

  /* ── 5. 1+1 rail ─────────────────────────────────────────────────────────── */
  function tiles() {
    var pick = q('#mini-cart [data-p11-pick]');
    if (!pick) { return; }
    var floor = parseInt(pick.getAttribute('data-p11-floor'), 10) || 0;
    /* the free word is the 1+1's rule (the pair's cheaper case is freed); a 2+2 store frees nothing for one more case */
    var word = OFFER === 'p11' ? t('pick_free') : '';
    var tl = pick.querySelectorAll('[data-p11-pick-open]'), i, c, el;
    for (i = 0; i < tl.length; i++) {
      c = parseInt(tl[i].getAttribute('data-p11-cents'), 10) || 0;
      el = tl[i].querySelector('.promo22__padd');
      if (el && word && c > 0 && floor > 0 && c <= floor) { el.textContent = word; }
      /* the design's name as the cart line writes it (no " 2.0"); data-p11-name, which promo22.js reports, is untouched */
      el = tl[i].querySelector('.promo22__pname');
      if (el) { el.textContent = String(el.textContent || '').replace(/\s+2\.0\s*$/, ''); }
    }
  }
  function showCfg() {
    W.requestAnimationFrame(function () {
      var box = q('#mini-cart [data-p11-config]');
      if (box && !box.hidden && box.scrollIntoView) { box.scrollIntoView({ block: 'nearest', behavior: calm() ? 'auto' : 'smooth' }); }
    });
  }

  /* ── 6. empty cart: the remembered phone ─────────────────────────────────── */
  function device() {
    var box = q('#mini-cart [data-u-empty]'), slots = qa('#mini-cart [data-u-slot-link]');
    if (!box && !slots.length) { return; }
    var o = null;
    try { o = JSON.parse(W.localStorage.getItem('mf_dev1') || 'null'); } catch (e) { o = null; }
    if (!o || o.v !== 1 || !o.l || !o.u) { return; }
    if (o.t && (Date.now() - o.t) > 15552000000) { return; }
    var path = String(o.u).split('?')[0].split('#')[0].replace(/\/+$/, '');
    if (!/^\/collections\/[^/]+$/.test(path)) { return; }
    var base = W.mfHref ? W.mfHref(path) : path;
    for (var s = 0; s < slots.length; s++) { slots[s].setAttribute('href', base); }
    if (!box) { return; }
    var label = String(o.l).replace(/^\s*(Apple|Samsung)\s+/i, '').trim();
    var cta = q('#mini-cart [data-u-dev-cta]'), txt = q('#mini-cart [data-u-dev-txt]'), i, m;
    if (cta) { cta.setAttribute('href', base); }
    var cta_t = label ? t('empty_cta', { device: label }) : '';
    if (txt && cta_t) { txt.textContent = cta_t; }
    m = box.querySelectorAll('a[data-u-mood]');
    for (i = 0; i < m.length; i++) { m[i].setAttribute('href', base + '/' + m[i].getAttribute('data-u-mood')); }
  }

  /* ── 7. delivery days ─────────────────────────────────────────────────────── */
  /* the store's weekday names, Sunday first (mf.up.cart.days, comma separated - as snippets/up-cart.liquid splits it) */
  var DAYS = t('days').split(',');
  function days() {
    var el = q('#mini-cart [data-u-days]');
    if (!el || DAYS.length !== 7) { return; }
    var d1 = parseInt(el.getAttribute('data-d1'), 10), d2 = parseInt(el.getAttribute('data-d2'), 10);
    if (!isFinite(d1) || !isFinite(d2)) { return; }
    var d0 = new Date(), a, b;
    d0.setHours(0, 0, 0, 0);
    a = new Date(d0); a.setDate(a.getDate() + d1);
    b = new Date(d0); b.setDate(b.getDate() + d2);
    var line = t('delivery', { from: DAYS[a.getDay()], to: DAYS[b.getDay()] });
    if (line) { el.textContent = line; }
    fitShip();
  }
  /* one line, as the mockup: only a pair of long weekday names would wrap at 390 px, and gets a hair less tracking */
  function fitShip() {
    var s = q('#mini-cart .u-ship');
    if (!s) { return; }
    s.classList.remove('u-tight');
    var lh = parseFloat(W.getComputedStyle(s).lineHeight) || 18;
    if (s.getBoundingClientRect().height > lh * 1.5) { s.classList.add('u-tight'); }
  }

  /* ── 8. focus after a repaint ────────────────────────────────────────────── */
  var refocus = null;
  var FOCUSABLE = 'line-item-quantity a, .u-qty button, [data-cart-protector-add], [data-u-code-rm], [data-u-code-open], [data-u-code-more]';
  function esc(s) { return W.CSS && W.CSS.escape ? W.CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&'); }
  function remember(el) {
    var line = el.closest('[data-cart-key]'), v = line ? (line.getAttribute('data-u-v') || '') : '', nth = 0, idx = -1, all, i;
    if (line) {
      /* the line's place among the lines of its variant, and the control's place among the line's controls: Shopify
         re-keys a line when its discounts change (a + or − on a 1+1 case re-allocates the free unit), and a − at 2
         becomes "Elimină" at 1, so the key and the label can both be gone after the repaint */
      if (v) { all = D.querySelectorAll('#mini-cart [data-u-v="' + esc(v) + '"]'); for (i = 0; i < all.length; i++) { if (all[i] === line) { nth = i; } } }
      all = line.querySelectorAll(FOCUSABLE);
      for (i = 0; i < all.length; i++) { if (all[i] === el) { idx = i; } }
    }
    refocus = {
      key: line ? line.getAttribute('data-cart-key') : '',
      v: v, nth: nth, idx: idx,
      label: el.getAttribute('aria-label') || '',
      text: String(el.textContent || '').trim(),
      t: Date.now(),
      fallback: ''
    };
  }
  function restore() {
    /* kept for a few seconds, not used once: one change can repaint the drawer more than once (the gift settles,
       cart:refresh after cart:updated), and each swap drops the focus again */
    var r = refocus, cd = q('#mini-cart'), a = D.activeElement, el = null, line = null, c, i, same;
    if (!r || !cd || !cd.hasAttribute('open') || Date.now() - r.t > 6000) { return; }
    if (a && a !== D.body && cd.contains(a)) { return; }
    if (r.key) { line = cd.querySelector('[data-cart-key="' + esc(r.key) + '"]'); }
    /* re-keyed: the same variant's line (the same one of several, else the first) */
    if (!line && r.v) {
      same = cd.querySelectorAll('[data-cart-key][data-u-v="' + esc(r.v) + '"]');
      if (same.length) { line = same[Math.min(r.nth || 0, same.length - 1)]; }
    }
    if (line) {
      c = line.querySelectorAll(FOCUSABLE);
      for (i = 0; i < c.length && !el; i++) {
        if (c[i].disabled) { continue; }
        if ((r.label && c[i].getAttribute('aria-label') === r.label) || (!r.label && String(c[i].textContent || '').trim() === r.text)) { el = c[i]; }
      }
      /* the control in the same place (a − whose label changed, a protector's Elimină that became its Adaugă) */
      if (!el && r.idx >= 0 && c[r.idx] && !c[r.idx].disabled) { el = c[r.idx]; }
      /* else the line's name - never its thumbnail, which is aria-hidden and out of the tab order */
      if (!el) { el = line.querySelector('h4 a[href]') || line.querySelector(FOCUSABLE.split(', ').map(function (s) { return s + ':not([disabled])'; }).join(', ')); }
    }
    if (!el && r.fallback) { el = cd.querySelector(r.fallback); }
    if (!el) { el = cd.querySelector('[data-action="close"]'); }
    if (el) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  }

  /* ── 9. the live drawer A/B's tags (mf_dr / mf_drc) ──────────────────────── */
  (function drClean() {
    var cd = D.getElementById('mini-cart');
    if (!cd || (!cd.getAttribute('data-cart-dr') && !cd.getAttribute('data-cart-drc'))) { return; }
    var n = 0, going = false, done = false;
    function full(c) { return !!c && Array.isArray(c.items) && typeof c.item_count === 'number'; }
    function tagged(c) { var a = (c && c.attributes) || {}; return !!(a.mf_dr || a.mf_drc); }
    function write() {
      if (going || done || n >= 3) { return; }
      going = true; n++;
      lock(function () {
        return fetch(W.mfHref ? W.mfHref('/cart/update.js') : '/cart/update.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { mf_dr: '', mf_drc: '' } }), keepalive: true
        });
      }).then(function (res) { going = false; if (res && res.ok) { done = true; } }, function () { going = false; });
    }
    function from(c) {
      if (done || !full(c) || !(c.item_count > 0)) { return; }
      if (tagged(c)) { write(); } else { done = true; }
    }
    ['cart:refresh', 'cart:updated'].forEach(function (name) {
      /* window, capture: sees the event whatever it was fired on (mf-dr.js's own rule) */
      W.addEventListener(name, function (ev) { from(ev && ev.detail && ev.detail.cart); }, true);
    });
    /* the cart at render already holds items: the tags the server printed go now */
    if (W.mfCart && typeof W.mfCart.count === 'function' && +W.mfCart.count() > 0) { write(); }
  })();

  function paint() {
    syncSum();
    tiles();
    device();
    days();
    if (errFor) {
      var input = q('#mini-cart [data-u-cform] input');
      if (input) {
        input.value = errFor;
        refocus = null;
        try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
      }
      showErr(t('code_rejected', { code: errFor }));
      errFor = '';
    } else {
      restore();
    }
  }

  /* ── delegated listeners ─────────────────────────────────────────────────── */
  H.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest || !t.closest('#mini-cart')) { return; }
    var b = t.closest('[data-u-sum]');
    if (b) { ev.preventDefault(); D.body.classList.toggle('u-sum-open'); syncSum(); return; }
    b = t.closest('[data-u-code-open]');
    if (b) {
      ev.preventDefault();
      D.body.classList.add('mf-cpn-reveal');
      syncSum();
      fieldFocus();
      return;
    }
    b = t.closest('[data-u-code-more]');
    if (b) {
      ev.preventDefault();
      D.body.classList.toggle('u-code-more');
      syncSum();
      if (D.body.classList.contains('u-code-more')) { fieldFocus(); }
      return;
    }
    b = t.closest(FOCUSABLE);
    if (b) { remember(b); }
    b = t.closest('[data-u-code-rm]');
    if (b) { ev.preventDefault(); removeCode(b); return; }
    b = t.closest('[data-u-slot-add]');
    if (b) {
      ev.preventDefault();
      var pick = q('#mini-cart [data-p11-pick]');
      if (pick && pick.scrollIntoView) { pick.scrollIntoView({ block: 'nearest', behavior: calm() ? 'auto' : 'smooth' }); }
      return;
    }
    if (t.closest('[data-p11-pick-open]')) { showCfg(); }
  }, false);

  H.addEventListener('submit', function (ev) {
    var f = ev.target && ev.target.closest && ev.target.closest('#mini-cart [data-u-cform]');
    if (!f) { return; }
    ev.preventDefault();
    apply(f);
  }, true);

  /* the line a quantity link is changing reads as busy until the drawer repaints (theme.js swaps it) */
  H.addEventListener('line-item-quantity:change:start', function (ev) {
    var l = ev.target && ev.target.closest && ev.target.closest('.u-lineadd, .u-line');
    if (!l) { return; }
    l.classList.add('u-busy');
    /* a request that fails leaves no repaint behind: the line comes back after a few seconds */
    W.setTimeout(function () { l.classList.remove('u-busy'); }, 6000);
  }, false);

  H.addEventListener('cart-drawer:loaded', paint, false);
  function boot() {
    liveRegion();
    paint();
    /* the line's width depends on the web font: measure again once it is in, and on a resize */
    try { if (D.fonts && D.fonts.ready) { D.fonts.ready.then(fitShip); } } catch (e) {}
    var rz = 0;
    W.addEventListener('resize', function () { W.clearTimeout(rz); rz = W.setTimeout(fitShip, 150); }, { passive: true });
  }
  if (D.readyState === 'loading') { D.addEventListener('DOMContentLoaded', boot, false); } else { boot(); }
})();
